import * as React from 'react'

import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import HelpCenterLink from 'modules/core/components/HelpCenterLink'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  error?: boolean
}

interface Info {
  title: string
  description: string
  icon: 'sign-post' | 'send-email-envelope'
  help_center?: string
}

export const NoConversationsView = ({ error }: Props) => {
  const { navigation } = useNavigation()

  const { title, description, icon, help_center }: Info = error
    ? {
        title: i18n.t('ats.messages.no_conversation.error.title'),
        description: i18n.t('ats.messages.no_conversation.error.description'),
        icon: 'sign-post',
      }
    : {
        title: i18n.t('ats.messages.no_conversation.title'),
        description: i18n.t('ats.messages.no_conversation.description'),
        icon: 'send-email-envelope',
        help_center: i18n.t('ats.messages.no_conversation.more_information'),
      }

  return (
    <Box gap="s12" padding="s64" alignItems="center" textAlign="center" justifyContent="center">
      <Icon.Large icon={icon}></Icon.Large>
      <Text.Normal weight="medium" color="grey1000">
        {title}
      </Text.Normal>
      <Text.Normal size="200">{description}</Text.Normal>
      <Button.Router to={navigation.ats.jobs.fullPath()}>
        {i18n.t('ats.messages.no_conversation.go_to_jobs')}
      </Button.Router>
      {help_center && <HelpCenterLink name="ats_message_board">{help_center}</HelpCenterLink>}
    </Box>
  )
}
